






































































































































































































































import { Component, Watch, Vue, Prop } from 'vue-property-decorator'
import ErrorInfo from '@/app/components/Common/ErrorInfo.vue'
import DateClass from '@/app/module/date'
import Error409Modal from '@/app/components/Common/Error409Modal.vue'
import Validator from '@/app/module/validator'
/* api */
import MachineRentStepUpdateApi from '@/app/model/api/machineRentStepUpdateApi'
import CommonClass from '@/app/module/common'

@Component({
  components: {
    ErrorInfo,
    Error409Modal
  }
})
export default class changeStatusModal extends Vue {
  @Prop() private data!: any

  @Watch('data')
  changeData (data: any) {
    this.actualDate = new Date()
    this.step = data.step
  }

  private actualDate: any = null
  private remarks: string = ''
  private step: string = ''
  private status: string = ''
  private show400ErrorMessage: boolean = false
  private showError409Modal: boolean = false
  private errorMessages: any = ''
  private alertText: string = ''
  private alertTitle: string = ''
  /* v-calender */
  private timezone: string = ''

  private doSave () {
    /* バリデーションチェック */
    if (!this.doValidate()) {
      window.scrollTo({ top: 0, behavior: 'auto' })
      this.alertText = ''
      this.alertTitle = ''
      this.show400ErrorMessage = true
      return
    } else {
      this.show400ErrorMessage = false
    }

    const data = {
      machine_rent_step: {
        step: this.data.step,
        actual_date: DateClass.dateToStringYmdhm(this.actualDate, '-'),
        is_canceled: this.data.is_canceled,
        remarks: this.remarks,
        time_stamp: this.data.time_stamp
      }
    }

    this.upDateStageData(data)
  }

  private doValidate () {
    const rentStatusRemarksFlag = Validator.validateInputRentStatusRemarks('rentStatusRemarksErrorMessage', this.remarks)
    this.errorMessages = Object.assign({}, this.errorMessages, Validator.getErrorMessage())

    return rentStatusRemarksFlag
  }

  private async upDateStageData (data: any) {
    const result = await MachineRentStepUpdateApi.doMachineRentStepUpdate(this.$route.params.machine_rent_id, data)

    if (result.isOk()) {
      // 完了アラート表示
      Vue.prototype.$alert.toast({ text: '貸出ステータスを変更しました。', type: 0 })

      this.$emit('do-save')
      // 項目リセット
      this.actualDate = new Date()
      this.remarks = ''
      this.show400ErrorMessage = false
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'PUT', 'text')
      if (errorData.status_code === '409') {
        this.showError409Modal = true
      } else {
        this.alertText = errorData.alertText
        this.alertTitle = errorData.alertTitle
        this.show400ErrorMessage = true
        window.scrollTo({ top: 0, behavior: 'auto' })
      }
    }
  }

  private closeModal () {
    this.$emit('close-modal')
    this.show400ErrorMessage = false
    this.remarks = ''
    for (let i in this.errorMessages) {
      this.errorMessages[i] = ''
    }
    this.actualDate = new Date()
  }
}
